import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Bell, Loader2, Send } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/notifications`;
const authHeaders = () => {
  const token = localStorage.getItem('salesspace_admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const PushPromoCard = () => {
  const [status, setStatus] = useState(null);
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [sending, setSending] = useState(false);

  useEffect(() => {
    axios.get(`${API}/status`, { headers: authHeaders() }).then(({ data }) => setStatus(data)).catch(() => setStatus(null));
  }, []);

  const send = async () => {
    if (!title.trim() || !body.trim()) return toast.error('Add a title and a message');
    setSending(true);
    try {
      const { data } = await axios.post(
        `${API}/topic`,
        { topic: 'promotions', title: title.trim(), body: body.trim() },
        { headers: authHeaders() }
      );
      if (data.success) {
        toast.success('Promotion sent to app users');
        setTitle('');
        setBody('');
      } else {
        toast.error('Push notifications are not set up yet');
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not send promotion');
    } finally {
      setSending(false);
    }
  };

  return (
    <Card className="h-fit" data-testid="push-promo-card">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <Bell className="w-4 h-4" /> App Push Promotion
        </CardTitle>
        <p className="text-xs text-muted-foreground" data-testid="push-status">
          {status
            ? `${status.configured ? 'Ready' : 'Not set up'} · ${status.registered_devices} device(s) registered`
            : 'Checking setup…'}
        </p>
      </CardHeader>
      <CardContent className="space-y-3">
        <Input placeholder="Title, e.g. Weekend flash sale" value={title} onChange={(e) => setTitle(e.target.value)} maxLength={60} data-testid="push-title-input" />
        <Textarea placeholder="Message, e.g. 20% off all fashion until Sunday" value={body} onChange={(e) => setBody(e.target.value)} maxLength={180} rows={2} data-testid="push-body-input" />
        <Button onClick={send} disabled={sending || !status?.configured} className="w-full gap-2" data-testid="push-send-btn">
          {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
          Send to all app users
        </Button>
      </CardContent>
    </Card>
  );
};

export default PushPromoCard;
